/* Extracted from sections/wishlist-page.liquid so it ships as a cached asset instead of inline JS. */
document.addEventListener('DOMContentLoaded', async () => {
      const container = document.getElementById('WishlistItems');
      const emptyState = document.getElementById('WishlistEmpty');
      
      // Get wishlist items from localStorage
      const getWishlistItems = () => {
        try {
          const items = localStorage.getItem('nycd_wishlist');
          return items ? JSON.parse(items) : [];
        } catch (error) {
          console.error('Error reading wishlist:', error);
          return [];
        }
      };

      const removeFromWishlist = (handle) => {
        const items = getWishlistItems();
        const index = items.indexOf(handle);
        if (index > -1) {
          items.splice(index, 1);
          localStorage.setItem('nycd_wishlist', JSON.stringify(items));
          window.dispatchEvent(new CustomEvent('wishlist-updated', { detail: { items } }));
          if (window.wishlistManager) {
            window.wishlistManager.updateWishlistCount();
            window.wishlistManager.updateWishlistButtons();
          }
          return true;
        }
        return false;
      };

      const wishlistHandles = getWishlistItems();

      if (wishlistHandles.length === 0) {
        container.classList.add('hidden');
        emptyState.classList.remove('hidden');
        return;
      }

      emptyState.classList.add('hidden');
      container.classList.remove('hidden');

      // Format money helper
      const formatMoney = (cents) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
      };

      // Format image URL
      const formatImageUrl = (url, size) => {
        if (!url) return '';
        const parts = url.split('.');
        const extension = parts.pop();
        return `${parts.join('.')}_${size}x${size}.${extension}`;
      };

      // Load products
      const loadProducts = async () => {
        container.innerHTML = '<div class="col-span-full text-center py-8"><p class="text-gray-600">Loading wishlist...</p></div>';

        const productPromises = wishlistHandles.map(async (handle) => {
          try {
            const response = await fetch(`/products/${handle}.js`);
            if (!response.ok) throw new Error('Product not found');
            const product = await response.json();
            return product;
          } catch (error) {
            console.error('Error fetching product:', handle, error);
            return null;
          }
        });

        const products = (await Promise.all(productPromises)).filter(p => p !== null);

        if (products.length === 0) {
          container.innerHTML = '';
          container.classList.add('hidden');
          emptyState.classList.remove('hidden');
          return;
        }

        // Render products
        container.innerHTML = products.map(product => {
          const imageUrl = product.featured_image 
            ? formatImageUrl(product.featured_image, 800)
            : (product.images && product.images.length > 0 ? formatImageUrl(product.images[0], 800) : '');
          
          const isOnSale = product.compare_at_price && product.compare_at_price > product.price;
          const discountPercent = isOnSale 
            ? Math.round((product.compare_at_price - product.price) / product.compare_at_price * 100)
            : 0;

          return `
            <div class="product-card group" data-product-handle="${product.handle}">
              <!-- Product Image Container -->
              <div class="relative mb-4 w-full aspect-square overflow-hidden bg-gray-200">
                <a href="${product.url}">
                  ${imageUrl 
                    ? `<img src="${imageUrl}" alt="${product.title}" class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" loading="lazy" />`
                    : `<div class="w-full h-full bg-gradient-to-br from-gray-300 to-gray-400 flex items-center justify-center"><span class="text-gray-500 text-sm">Product Image</span></div>`
                  }
                  ${isOnSale 
                    ? `<div class="absolute top-2 left-2"><span class="bg-blue-200 text-white px-2 py-1 rounded-full text-xs font-medium">On Sale</span></div>`
                    : ''
                  }
                  ${product.tags && product.tags.includes('Best Seller')
                    ? `<div class="absolute top-2 left-2"><span class="bg-purple-200 text-white px-2 py-1 rounded-full text-xs font-medium">Best Seller</span></div>`
                    : ''
                  }
                </a>
                <!-- Wishlist Icon (Bottom Right) - Same style as product page -->
                <button 
                  data-wishlist-handle="${product.handle}"
                  class="absolute bottom-2 right-2 p-2 cursor-pointer transition-all duration-300 wishlist-button"
                  aria-label="Remove from wishlist"
                >
                  <svg class="w-4 h-4 md:w-[25px] md:h-[22px]" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.64583 0.00902295C4.78333 0.10569 3.00833 1.01152 1.79583 2.41736C0.583333 3.81736 0 5.66402 0 7.50902C0 9.12402 0.580833 10.689 1.37167 12.059C2.16333 13.429 3.19667 14.6232 4.28833 15.7207C6.64167 18.0815 9.355 20.0807 12.3067 21.629C12.4275 21.6924 12.5733 21.6924 12.6933 21.629C15.6458 20.0807 18.3583 18.0815 20.7117 15.7207C21.8033 14.6232 22.8367 13.429 23.6283 12.0599C24.42 10.6899 25 9.12569 25 7.50902C25 5.65902 24.4167 3.81902 23.205 2.41736C21.9917 1.01069 20.2167 0.104856 18.355 0.00902295C17.0917 -0.0559771 15.8175 0.247356 14.72 0.87569C13.8058 1.39736 13.0742 2.17402 12.5 3.05402C11.925 2.17402 11.1942 1.39736 10.28 0.874856C9.18333 0.246523 7.9075 -0.0576437 6.64583 0.00902295ZM6.6875 0.842356C7.7875 0.78569 8.90833 1.05069 9.865 1.59736C10.8217 2.14402 11.6208 2.97402 12.1317 3.95069C12.2867 4.25069 12.7133 4.25069 12.8692 3.95069C13.3792 2.97402 14.1775 2.14402 15.1358 1.59736C16.0917 1.05069 17.2108 0.78569 18.3125 0.842356C19.9308 0.92569 21.51 1.72736 22.575 2.95902C23.6417 4.19486 24.1667 5.84236 24.1667 7.50902C24.1667 8.95069 23.6433 10.3674 22.9067 11.6424C22.1692 12.9215 21.1867 14.0624 20.1217 15.1307C17.8833 17.3782 15.2983 19.2765 12.5 20.769C9.70167 19.2774 7.11667 17.3774 4.87833 15.1307C3.81333 14.0624 2.83083 12.9224 2.09333 11.6432C1.35667 10.3674 0.833333 8.95069 0.833333 7.50902C0.833333 5.84236 1.35833 4.19402 2.425 2.95902C3.49 1.72819 5.06917 0.92569 6.6875 0.842356Z" fill="black" fill-opacity="0.24"/>
                  </svg>
                </button>
              </div>

              <!-- Product Title -->
              <h3 class="mb-2 md:mb-4 text-base md:text-xl leading-6 md:leading-7 text-[#111] font-light">
                <a href="${product.url}" class="hover:underline">${product.title}</a>
              </h3>

              <!-- Price -->
              <div class="mb-2 md:mb-4 flex items-center gap-2">
                ${isOnSale 
                  ? `
                    <span class="text-base md:text-lg line-through text-gray-500 font-light">${formatMoney(product.compare_at_price)}</span>
                    <span class="text-base md:text-lg text-[#111] font-light">${formatMoney(product.price)}</span>
                    <span class="bg-green-100 text-green-700 px-2 py-0.5 rounded-lg text-sm font-normal">-${discountPercent}%</span>
                  `
                  : `<span class="text-base md:text-lg text-[#111] font-light">${formatMoney(product.price)}</span>`
                }
              </div>

              <!-- Add to Cart Button -->
              <button 
                class="w-full bg-[#0C1A70] text-white py-3 px-4 rounded hover:opacity-90 transition-opacity font-medium"
                onclick="window.location.href='${product.url}'"
              >
                View Product
              </button>
            </div>
          `;
        }).join('');

        // Update wishlist button states after rendering (they should all be filled since they're in wishlist)
        setTimeout(() => {
          if (window.wishlistManager) {
            window.wishlistManager.updateWishlistButtons();
          } else {
            // Fallback: manually set all buttons to active state
            container.querySelectorAll('[data-wishlist-handle]').forEach(button => {
              const svg = button.querySelector('svg');
              const path = svg?.querySelector('path');
              if (path) {
                path.setAttribute('fill', 'currentColor');
                path.setAttribute('fill-opacity', '1');
                button.classList.add('wishlist-active');
                button.setAttribute('aria-label', 'Remove from wishlist');
              }
            });
          }
        }, 100);

        // Listen for wishlist updates to remove products from page
        const handleWishlistUpdate = () => {
          const currentHandles = getWishlistItems();
          const productCards = container.querySelectorAll('.product-card');
          
          productCards.forEach(card => {
            const handle = card.getAttribute('data-product-handle');
            if (handle && !currentHandles.includes(handle)) {
              // Product was removed from wishlist, animate and remove
              card.style.transition = 'opacity 0.3s, transform 0.3s';
              card.style.opacity = '0';
              card.style.transform = 'scale(0.9)';
              setTimeout(() => {
                card.remove();
                
                // Check if wishlist is now empty
                const remainingProducts = container.querySelectorAll('.product-card');
                if (remainingProducts.length === 0) {
                  container.classList.add('hidden');
                  emptyState.classList.remove('hidden');
                }
              }, 300);
            }
          });
        };

        window.addEventListener('wishlist-updated', handleWishlistUpdate);
      };

      // Load products
      await loadProducts();
    });
